module.exports = __webpack_public_path__ + "static/img/13.6deae07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/13.png
// module id = YMF4
// module chunks = 0